import React from 'react'

interface Props {
  width: string
  height: string
  fill: string
}

export const IconDomainsCount = ({ width = '24px', height = '24px', fill = '#000' }: Props) => (
  <svg width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g fill={fill}>
      <circle cx="7" cy="7" r="3" />
      <circle cx="17" cy="7" r="3" />
      <circle cx="12" cy="17" r="3" />
    </g>
  </svg>
)

export default IconDomainsCount
